// 求线段与垂直线夹角，以12点钟为0度
const lineIncludedAngle = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  baseDeg: number,
): number | void => {
  baseDeg = baseDeg || 0;
  if (x1 === x2 && y1 === y2) {
    throw new Error('两点必须构成一条线段');
  }
  let a, b;
  // 四种情况，1234象限
  if (y2 < y1 && x2 > x1) {
    a = x2 - x1;
    b = y1 - y2;
    a = Math.abs(a);
    b = Math.abs(b);
    const tan = a / b;
    const rad = Math.atan(tan);
    const deg = rad / (Math.PI / 180);
    return deg - baseDeg;
  } else if (y2 > y1 && x2 > x1) {
    a = x2 - x1;
    b = y2 - y1;
    a = Math.abs(a);
    b = Math.abs(b);
    const tan = b / a;
    const rad = Math.atan(tan);
    const deg = rad / (Math.PI / 180);
    return deg + 90 - baseDeg;
  } else if (y2 > y1 && x2 < x1) {
    a = x1 - x2;
    b = y1 - y2;
    a = Math.abs(a);
    b = Math.abs(b);
    const tan = a / b;
    const rad = Math.atan(tan);
    const deg = rad / (Math.PI / 180);
    return deg + 180 - baseDeg;
  } else if (y2 < y1 && x2 < x1) {
    a = x1 - x2;
    b = y1 - y2;
    a = Math.abs(a);
    b = Math.abs(b);
    const tan = a / b;
    const rad = Math.atan(tan);
    const deg = rad / (Math.PI / 180);
    return 360 - deg - baseDeg;
  }
  // 在水平或垂直时的特殊情况
  else if (y1 === y2 && x2 > x1) {
    return 90 - baseDeg;
  } else if (y1 === y2 && x2 < x1) {
    return 270 - baseDeg;
  } else if (x1 === x2 && y2 > y1) {
    return 180 - baseDeg;
  } else if (x1 === x2 && y2 < y1) {
    return 0 - baseDeg;
  }
};

export default lineIncludedAngle;
